import {ChangeDetectionStrategy, Component, inject, input} from '@angular/core';
import {Store} from '@ngrx/store';
import {MatDialog} from '@angular/material/dialog';
import {PaperHasEmbeddingDTO} from '../../dto/embedding';
import {ResearchPaperDTO} from '../../../research/dto/research-paper';
import {selectPapersByProjectIdAndPaperId} from '../../../research/services/research-paper/research-paper.selectors';
import {
  ResearchPaperDialogComponent
} from '../../../research/components/research-paper-dialog/research-paper-dialog.component';
import {MatCardModule} from '@angular/material/card';
import {PaperEmbeddingDetailComponent} from '../paper-embedding-detail/paper-embedding-detail.component';
import {MatButtonModule} from '@angular/material/button';
import {combineLatest} from 'rxjs';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {switchMap} from 'rxjs/operators';

@Component({
  selector: 'app-paper-has-embedding-paper-card',
  imports: [MatCardModule, MatButtonModule],
  templateUrl: './paper-has-embedding-paper-card.component.html',
  styleUrl: './paper-has-embedding-paper-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaperHasEmbeddingPaperCardComponent {
  private readonly store: Store = inject(Store);
  private readonly dialog: MatDialog = inject(MatDialog);

  readonly hasEmbedding = input.required<PaperHasEmbeddingDTO>();
  readonly projectId = input.required<number>();
  readonly isSmallScreen = input<boolean>(false);

  readonly paper = toSignal(
    combineLatest([toObservable(this.projectId), toObservable(this.hasEmbedding)]).pipe(
      switchMap(([projectId, hasEmbedding]) =>
        this.store.select(selectPapersByProjectIdAndPaperId(projectId, hasEmbedding.paperId))
      )
    ),
    {initialValue: undefined as ResearchPaperDTO | undefined}
  );

  viewEmbeddings(): void {
    this.dialog.open(PaperEmbeddingDetailComponent, {
      data: this.hasEmbedding(),
      width: this.isSmallScreen() ? '100vw' : '80%',
      height: this.isSmallScreen() ? '100vh' : '80%',
      maxWidth: '100vw',
    });

  }

  viewDetails(paper: ResearchPaperDTO): void {
    this.dialog.open(ResearchPaperDialogComponent, {
      data: {
        isMobile: this.isSmallScreen(),
        paper: paper
      },
      autoFocus: false,
      width: this.isSmallScreen() ? '100vw' : '90%',
      height: this.isSmallScreen() ? '100vh' : '90%',
      maxWidth: '100vw',
    });

  }

}
